import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Filter, FilterProps } from './filter';

export interface UrlFilterProps
    extends Omit<FilterProps, 'searchParams' | 'onUpdateSearchParams' | 'defaultSearchParams'> {
    onSearchParamsChange?: (searchParams: URLSearchParams) => void;
}

export const UrlFilter = (props: UrlFilterProps) => {
    const { onSearchParamsChange, ...filterProps } = props;
    const [urlSearchParams, setUrlSearchParams] = useSearchParams();

    useEffect(() => {
        onSearchParamsChange?.(urlSearchParams);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [urlSearchParams]);

    return <Filter {...filterProps} searchParams={urlSearchParams} onUpdateSearchParams={setUrlSearchParams} />;
};
